import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  apiUrl: 'https://dev-alt-14-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-14-api.eshyft.com',
  loginRedirectUrl: 'https://dev-alt-14-admin.eshyft.com/',
  firebaseTenantId: 'dev-alt-14-g7d6o',
}
